<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="partnoAlt"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Alternate PN</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <!--<v-btn @click="listPartnoAlt()" color="primary" dark class="mb-2">Seach</v-btn> -->
                    <v-spacer></v-spacer>        
               <template>
                    <v-row justify="center">
                        <v-dialog v-model="dialog" persistent max-width="650px">
                        <template v-slot:activator="{ on }" >
                            <v-btn color="primary" dark v-on="on">New</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                           
                            <v-card-text>                            
                            <v-container>                              
                                <v-flex xs12 sm12 md12 lg12 xl12>
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">  </div>
                                </v-flex>   
                                <v-row>
                                    <v-col cols="12" sm="6" md="4"> 
                                        <div v-if="editedIndex > -1">                                            
                                            <v-text-field readonly v-model="id" label="ID" filled required></v-text-field>                                            
                                        </div>                                                                         
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="part_number" label="Part Number" ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="part_number_alt" label="Part Number Alt" ></v-text-field>
                                    </v-col>                                                                   
                                                                                                
                                </v-row>                            
                            </v-container>
                            <small>*indicates required field</small>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>                            
                                <v-btn
                                    :disabled="dialogLoading"
                                    :loading="dialogLoading"
                                    color="blue darken-1" text @click="save"
                                    >
                                    Save
                                </v-btn>
                            
                           
                           <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Saving, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>            

                            </v-card-actions>
                        </v-card>
                        </v-dialog>
                    </v-row>
                </template>
            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.ID">
                            <td>
                                <div >  
                                    <div >                                  
                                        <v-icon small class="mr-2" @click="editItem(item)">
                                            edit
                                        </v-icon>
                                    </div>
                                </div>                                                                     
                            </td>                  
                                                     
                            <td class="text-xs-right">{{item.part_number}} </td>
                            <td class="text-xs-right">{{item.part_number_alt}} </td>                            
                            <td class="text-xs-right">{{moment(item.create_dt).format('MM/DD/YYYY HH:mm')}} </td>                            

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
   
    export default{
        components: {
                     
        },       
        data (){
            return {
                  moment:moment,                
                  partnoAlt:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },                        
                       // { text: 'ID', value: 'id', sortable: false },
                        { text: 'Part Number', value: 'part_number', sortable: false },
                        { text: 'Part Number Alt', value: 'part_number_alt', sortable: false },                        
                        { text: 'Create DT', value: 'create_dt', sortable: false }                      
                    ],
                    //moment: moment, // Set to whatever
                    //privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    id: '', 
                    part_number: '', 
                    part_number_alt: '', 
                    create_dt: '', 
                                      
                   
                    valida:0,
                    validaMensaje:[]   
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Part Number' : 'Edit Part Number'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();
            this.listPartnoAlt();
            //this.havePriviges();     
        },

         methods: { 
           //   havePriviges() {
            //    this.$store.state.user.rol === "yms_customs" ? this.privileges =false : this.privileges =true
            //} ,           
            listPartnoAlt(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                url ='api/dell_mod_s_partno_alt/List';
                //if (!me.search){
                //    url ='api/dell_mod_s_partno_alt/List';
                //}
                //else{
                //    url ='api/Invoices/ListFilter/' + me.search;
                //}
                axios.get(url,configuration).then(function(response){
                    //console.log(response);
                    me.partnoAlt = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {                            
            },
            
            editItem (item) {
                                               
                this.id= item.id;  
                this.part_number= item.part_number; 
                this.part_number_alt= item.part_number_alt; 
                this.create_dt= item.create_dt;
                      
                this.editedIndex=1;
                this.dialog = true
            },

            deleteItem (item) {
                const index = this.desserts.indexOf(item)
                confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {               

                this.id= ""; 
                this.part_number= "";
                this.part_number_alt= "";
                this.create_dt= ""; 
                  

                this.editedIndex=-1;

                this.valida= 0;
                this.validaMensaje= [];

            },           
          
            save () {               
                if (this.validar() > 0)  {                                      
                     return;   
                }                 
                
                if (this.editedIndex > -1) {                   
                   //Code for Edit Mode
                   this.dialogLoading = true;
                   let me=this;
                   let header={"Authorization": "Bearer " + this.$store.state.token};
                   let configuration = {headers : header };
                   axios.put('api/Invoices/Update',{                                                   
                        'invoiceID':me.id,                                         
                        'transportDestination': me.transportDestination,
                        'operatorName': me.operatorName, 
                        'boxNo': me.boxNo,
                        'boxPlate': me.boxPlate,
                        'economicNo': me.economicNo,
                        'tractorPlate': me.tractorPlate,
                        'sealNo': me.sealNo,
                        'delivery_dt': me.delivery_dt, 
                        'updater': me.creator      
                    },configuration).then(function(response){
                        me.close();
                        me.listInvoices();
                        me.clean();
                    }).catch(function(error){                        
                        console.log(error);
                        this.errored = true;
                    }).finally(() => this.dialogLoading  = false);                   

                } else {                    
                    //Code for Save                   
                   if (this.validar()){
                       return;
                   }

                    let me=this;    
                    let header={"Authorization": "Bearer " + this.$store.state.token};
                    let configuration = {headers : header };
                    this.dialogLoading = true;         
                    axios.post('api/Invoices/Create',{                                                   
                            'invoiceNo': me.invoiceNo,                  
                            'transportDestination': me.transportDestination,
                            'operatorName': me.operatorName, 
                            'boxNo': me.boxNo,
                            'boxPlate': me.boxPlate,
                            'economicNo': me.economicNo,
                            'tractorPlate': me.tractorPlate,
                            'sealNo': me.sealNo,
                            'delivery_dt': me.delivery_dt, 
                            'creator': me.creator               
                    },configuration).then(function(response){
                        console.log('Save');
                        me.close();
                        me.listInvoices();
                        me.clean();
                    }).catch(function(error){                     
                       console.log(error);
                    }).finally(() => this.dialogLoading  = false,
                        this.validaMensaje.push('The Invoice number is already registered.')
                    );  
                   
                }               
            },
           
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.invoiceNo){
                     this.validaMensaje.push('Input the Invoice Number');
                 }   
                 if (!this.delivery_dt){
                     this.validaMensaje.push('Input the Delivery Date');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;                    
                }                                             
                 return this.valida;
            },
        },
    }
</script>